//import { OrderReviewComponent } from "../components/order-review/order-review.component";
import { ConfigService } from "../services/config.service";
import { DetailedQuotaComponent } from "../screens/detailed-quota/detailed-quota.component";
import { SlickMarketWatchComponent } from "../components/slick-market-watch/slick-market-watch.component";
import { ApiService } from "../services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { MarketNewsComponent } from "../components/market-news/market-news.component";
import { OrderBookComponent } from "../components/order-book/order-book.component";
import { MarketTradesComponent } from "../components/market-trades/market-trades.component";
import { MarketDepthComponent } from "../components/market-depth/market-depth.component";
import { GridsterService } from "../services/gridster.service";
import { MarketDepthBidsComponent } from "../components/market-depth-bids/market-depth-bids.component";
import { MarketDepthAsksComponent } from "../components/market-depth-asks/market-depth-asks.component";
import { TradesComponent } from "../components/trades/trades.component";
import { NewsComponent } from "../components/news/news.component";
import { HistoricalComponent } from "../components/historical/historical.component";
import {
  ChangeDetectorRef,
  OnInit,
  QueryList,
  ViewChildren,
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
  Injectable,
} from "@angular/core";
import { CompanyList } from "src/app/models/company-list";
import {
  GridsterConfig,
  GridsterItem,
} from "angular-gridster2";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AccountService } from "src/app/services/account.service";
import { UserIdleService } from "angular-user-idle";
import { SignalRService } from "src/app/services/signalr.service";
import { ToastrService } from "ngx-toastr";
import 'zone.js/dist/zone';
import {
  IgcContentPane,
  IgcDockManagerComponent,
  IgcDockManagerLayout,
  IgcDockManagerPaneType,
  IgcPaneCloseEventArgs,
  IgcSplitPane,
  IgcSplitPaneOrientation,
  IgcDockManagerPane,
  IgcDockManagerPoint
} from 'docking-egid';
import { defineCustomElements } from 'docking-egid/loader';
import { FlexLayoutService } from "src/app/services/flex-layout.service";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { CompanyDepth } from "../models/company-depth";
import { UrlConstants } from "../models/urlConstants";
import * as signalR from "@microsoft/signalr";
import { MarketWatchDetailService, StockDetail } from "./market-watch-detail.service";
import { MarketTrades } from "../models/company-trades";

@Injectable({
    providedIn: "root",
  })

export class HomeComponentsServices 
{
    private depthConnection: HubConnection;
    http: any;
    constructor(private _service: ApiService,
        private signalService: SignalRService,
        private _marketDetail: MarketWatchDetailService
    ) {}

    fetchCompanyNews(symbolCode: string) {
        return this._service.fetchCompanyNews(symbolCode);
      }

      fetchDepthByOrder(symbolCode: string) {
        return this._service.fetchDepthByOrder(symbolCode);
      }
    
      fetchDepthByPrice(symbolCode: string) {
        return this._service.fetchDepthByPrice(symbolCode,10);///WRONG  no 0 here check component
      }
    
      connectSignalR(symbolCode: string) {
        const depthConnection = new HubConnectionBuilder()
          .withUrl(UrlConstants.newSignalR + "/bidsAsksHub", {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .build();
    
        return depthConnection.start().then(() => {
          return depthConnection.invoke("JoinGroup", symbolCode).then(() => {
            return depthConnection;
          });
        });
      }
    
      stopSignalRConnection(connection: HubConnection) {
        if (connection) connection.stop();
      }
      fetchMarketTrades() {
        return this._service.fetchMarketTrades();
      }
    
      subscribeToTradeUpdates(allMarketNames: StockDetail[], callback: (trade: MarketTrades) => void) {
        this.signalService.tradeChanges.subscribe((res) => {
          if (allMarketNames) {
            res.reverse();
            res.forEach((trade) => {
              this.updateStockDetail(trade, allMarketNames);
              callback(trade);
            });
          }
        });
      }
    
      updateStockDetail(trade: MarketTrades, allMarketNames: StockDetail[]) {
        if (trade && allMarketNames) {
          const companyDetail = allMarketNames.find((x) => x['SYMBOL_CODE'] === trade.SEC_BORAD_ID);
          if (companyDetail) {
            trade.ARB_Name = companyDetail['arb_shortname'];
            trade.ENG_Name = companyDetail['eng_shortname'];
            trade.REUTERS = companyDetail['Reuters'];
          }
        }
      }
    
      getMarketNames() {
        return this._marketDetail.marketNames?.getValue();
      }
    
      subscribeToMarketNames(callback: (names: StockDetail[]) => void) {
        this._marketDetail.namesSubject.subscribe((res) => {
          callback(res as StockDetail[]);
        });
      }

      fetchCompanyTradesByPrice(symbolCode: string) {
        return this._service.fetchCompanyTrades(symbolCode);
      }
    
      fetchCompanyTradesByTime(symbolCode: string) {
        return this._service.fetchCompanyTradesByTime(symbolCode);
      }

      fetchCompanyMarketDepth(symbolCode: string,startDate: Date, endDate: Date) {
        if (symbolCode) {
          return this.http.post(
            UrlConstants.feedUrl + "/api/Feed/GetSymbolHistory",
            {
              SymbolCode: symbolCode,
              Skip: 0,
              Take: 1000,
              FromDate: startDate,
              ToDate: endDate,
            }
          );
        }
      }
    
    //   toggleOrderView(symbolCode: string, isOrder: boolean, otherComponentInstance: any) {
    //     otherComponentInstance.isDepthLoading = true;
    //     otherComponentInstance.isOrder = isOrder;
    //     if (isOrder) {
    //       this.fetchDepthByOrder(symbolCode, otherComponentInstance);
    //     } else {
    //       this.fetchDepthByPrice(symbolCode, otherComponentInstance);
    //     }
    //   }  
}